import * as React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"

export default function ImageIcon(props: IconProps) {
  return (
    <IconSkeleton {...props} iconName="ImageIcon">
      <path
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        d="M1,3 L23,3 L23,21 L1,21 L1,3 Z M6,9 C6.55228475,9 7,8.55228475 7,8 C7,7.44771525 6.55228475,7 6,7 C5.44771525,7 5,7.44771525 5,8 C5,8.55228475 5.44771525,9 6,9 Z M23,15 L18,9 L12,16 L9,13 L1,21"
      ></path>
    </IconSkeleton>
  )
}
